window.modal_show = function(){
  // const top_position = $(window).scrollTop();
  $("body").css({"overflow" : "hidden"});
  $(".main-modal-wrapper").css("width", "");
  $(".area-modal-wrapper").show();
  let modal = $(".main-modal-wrapper");
  let custom_width = modal.find(".content-modal-wrapper").attr("data-custom-width-modal");
  custom_width ? modal.css("width", custom_width) : "";
  const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  let top = (height / 2 - modal.height() / 2);
  top = top > 10 ? top : 10;
  modal.css({"margin-top": top});
};

window.modal_hide = function(){
  const top_position = $(window).scrollTop();
  $("body").css({"overflow" : "auto", "height" : "auto"});
  $(window).scrollTop(top_position);
  let url = $('.content-modal-wrapper').data('hide-url');
  $(".area-modal-wrapper").removeClass("video-modal");
  $(".area-modal-wrapper").hide();
  $(".inner-content-wrapper").html("");
  $(".main-modal-wrapper").css("width", "");
  if($("#ui-id-1").length > 0) {
    $("#ui-id-1, .ui-helper-hidden-accessible").remove();
  }
  if (url) {
    window.history.pushState(null, null, url);
  }
};

window.word_form = function( num, word ){
  let cases = [2, 0, 1, 1, 1, 2];
  return word[ (num%100>4 && num%100<20) ? 2 : cases[(num%10<5)?num%10:5] ];
};

window.json_for_attr = function(obj){
  return JSON.stringify(obj).replace(/"/g, "'");
};

window.json_from_attr = function(string){
  return JSON.parse(string.replace(/'/g, '"'));
};

window.refreshDatatable = function(){
  if (typeof data_table_controller !== 'undefined') {
    data_table_controller.datatable_obj.page.resetMore();
    data_table_controller.datatable_obj.ajax.reload();
    return true;
  }
  
  if (typeof project_dashboard_controller !== 'undefined') {
    project_dashboard_controller.recreateDashboard();
    return true;
  }
  
  return false;
};

window.error_show = function(error_data){
  toastr.error(error_data.join('\n'));
};

window.set_ls_table_filters = function(obj){
  localStorage.setItem('goodok_table_filters', JSON.stringify(obj));
};

window.getMeta = function(metaName) {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }

  return '';
};

window.custom_dropdown_click = function(element){
  let el = $(element);
  let wrapper = el.parents("[data-type='dropdown']");
  wrapper.find("[data-type='current-option']").html(el.html());
  wrapper.find("[data-toggle='dropdown']").click();
}

window.imagePreviewShow = function(src){
  const wrapper = document.getElementById("image-preview-modal");
  if (!wrapper) return;
  wrapper.querySelector(".image-preview-modal__img").src = src;
  document.body.style.overflow = "hidden";
  wrapper.classList.add("shown");
};

window.imagePreviewHide = function(){
  const wrapper = document.getElementById("image-preview-modal");
  if (!wrapper) return;
  wrapper.classList.remove("shown");
  wrapper.querySelector(".image-preview-modal__img").src = "";
  document.body.style.overflow = "auto";
};

document.addEventListener("click", function(event){
  const link = event.target.closest(".js-image-preview");
  if (!link) return;

  event.preventDefault();
  window.imagePreviewShow(link.href);
});

window.convertLocalTime = function(container) {
  const elements = (container || document).querySelectorAll("[data-local-time]");
  elements.forEach(function(el) {
    const utcDate = new Date(el.getAttribute("datetime"));
    if (isNaN(utcDate)) return;

    const pad = function(n) { return n < 10 ? "0" + n : n; };
    const formatted = pad(utcDate.getDate()) + "." + pad(utcDate.getMonth() + 1) + "." +
      utcDate.getFullYear() + " в " + pad(utcDate.getHours()) + ":" + pad(utcDate.getMinutes());
    el.textContent = formatted;
  });
};

export default function(){}